import StatementListing from './StatementListing';

export default StatementListing;
